import React from "react";
import { Layout, Typography, Button } from "antd";
import { useNavigate } from "react-router-dom";

const { Content, Footer } = Layout;
const { Title, Paragraph } = Typography;

function ErrorPage() {
  const navigate = useNavigate();

  return (
    <Layout
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "#f5f6fa",
        fontFamily: "Poppins, sans-serif",
      }}
    >
         <div className="top-bar">
        <img
          src={require("./assets/meet.png")}
          alt="Company Logo"
          className="logo"
        />
        {/* {company?.company_name && (
          <span className="company-name">{company.company_name}</span>
        )} */}
      </div>
      {/* 🔹 Content Centered */}
      <Content
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          textAlign: "center",
        }}
      >
        <Title level={1} style={{ color: "#ff4d4f", fontSize: "72px", marginBottom: 0 }}>
          404
        </Title>
        <Paragraph style={{ fontSize: "18px", color: "#333", marginBottom: 24 }}>
          This page does not exist
        </Paragraph>

        <Button
          type="primary"
          onClick={() => navigate("/")}
          style={{
            backgroundColor: "#1890ff",
            borderRadius: "6px",
            padding: "0 24px",
            height: "40px",
            fontWeight: 500,
          }}
        >
          Go Back to Home
        </Button>
      </Content>

      {/* 🔹 Footer */}
      <Footer
        style={{
          textAlign: "center",
          fontSize: "14px",
          color: "#888",
          background: "transparent",
          padding: "12px 0",
        }}
      >
        © 2025 Foster Digital Technology Pvt Ltd.
      </Footer>
    </Layout>
  );
}

export default ErrorPage;
